<template>
    <v-container class="unauthenticated fill-height" fluid>
        <v-row class="unauthenticated__login" align="center" justify="center">
            <v-col cols="12" md="8">
                <v-card raised class="mx-auto" max-width="540px">
                    <v-img height="140px" src="../../assets/backgrounds/unauthenticated_cover.jpg">
                    </v-img>
                    <v-card-title class="headline">Residence Application Portal</v-card-title>
                    <v-card-subtitle class="font-weight-medium pb-0">King's University College</v-card-subtitle>
                    <v-card-text class="text--primary">
                        <h4>
                            To access the Residence Application Portal, you must sign in to the myKing's Staff Portal or
                            Student Portal.
                        </h4>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn ref="staffBtn" @click="staffLogin()" :href="staffLink" raised color="#003F36"
                            class="white--text">
                            Sign in as staff
                        </v-btn>
                        <v-btn ref="studentBtn" @click="studentLogin()" :href="studentLink" raised color="#003F36"
                            class="white--text">
                            Sign in as student
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'unauthenticated',
    data() {
        return {
            staffLink: `https://${location.hostname}/cgi-bin/mkvn/app.pl?staff&redirect=1`,
            studentLink: `https://${location.hostname}/cgi-bin/mkvn/app.pl?student&redirect=1`
        }
    },
    methods: {
        staffLogin() {
            this.$refs.staffBtn.loading = true;
        },
        studentLogin() {
            this.$refs.studentBtn.loading = true;
        }
    }
}
</script>

<style scoped>
.headline {
    word-break: normal;
}

.unauthenticated {
    background-image: url('../../assets/backgrounds/unauthenticated_bg.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
}
</style>